<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4y2jRP/image/cover.jpg?1731429793762" alt="This image is the cover for the book Everyday Witch's Coven"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Everyday Witch's Coven
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Practical Spells, Rituals, and Advice for Modern and Eclectic Covens</b><br/><br/>Whether your coven consists of two or twenty, whether you want to gather on a regular basis or just occasionally, this book has what you need to practice Witchcraft with others. Deborah Blake draws on nearly twenty years of experience leading a coven, sharing extensive wisdom she's gained from her experiences and fellow practitioners. This book is a valuable resource for traditional Wiccans and eclectic witches looking for a modern approach to group activities.<br/><br/>The Everyday Witch's Coven helps you decide who to invite, where to meet, which deities to worship, and how to solve problems together. You'll explore ritual basics and etiquette, group sabbat celebrations, full moon rituals, craft projects, and magic for specific goals like love and healing. From guided meditations to making a Book of Shadows for your group, Deborah provides a multitude of ways to find or create a coven that's best for you.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Deborah Blake
      </h2>
      
      <p class="authorDescription body article"><P><B>Deborah Blake</B> is the author of seventeen books on modern Witchcraft, including <I>The Eclectic Witch's Book of Shadows</I>, <I>The Little Book of Cat Magic</I>, and <I>Llewellyn's Little Book of Spellcraft</I>, as well as the acclaimed <I>Everyday Witch Tarot</I>, <I>Everyday Witch Oracle</I>, and <I>Everyday Witch’s Familiars Oracle</I>. She has also written three paranormal romance and urban fantasy series for Berkley, and as well as a cozy mystery series about a run-down pet rescue. Deborah lives in a 140-year-old farmhouse in upstate New York with numerous cats who supervise all her activities, both magical and mundane. She can be found at DeborahBlakeAuthor.com.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Llewellyn Publications is an imprint of Llewellyn Worldwide Ltd. 
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6e281b70